export default "__VITE_ASSET__4b9e674b__"